import Vue from 'vue'
import VueRouter from 'vue-router'
import Shipment from '@/views/Shipments.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: { name: 'shipments' },
      meta: {
        auth: true
      }
    },
    {
      path: '/planner',
      name: 'planner',
      component: () => import(/* webpackChunkName: "products" */ '@/views/Planner.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/shipments',
      name: 'shipments',
      component: Shipment,
      meta: {
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      }
    },
    {
      path: '/products',
      name: 'products',
      component: () => import(/* webpackChunkName: "products" */ '@/views/Products.vue'),
      meta: {
        title: Vue.i18n.translate('strings.products', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'productsDetail',
        component: () => import(/* webpackChunkName: "products" */ '@/views/Products.vue')
      }]
    },
    {
      path: '/label_groups',
      name: 'label_groups',
      component: () => import(/* webpackChunkName: "label_groups" */ '@/views/LabelGroups.vue'),
      meta: {
        title: Vue.i18n.translate('strings.label_groups', null),
        auth: {
          roles: ['Admin', 'Almacenista', 'Vendedor'],
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'labelGroupsDetail',
        component: () => import(/* webpackChunkName: "label_groups" */ '@/views/LabelGroups.vue')
      }]
    },
    {
      path: '/labels',
      name: 'labels',
      component: () => import(/* webpackChunkName: "labels" */ '@/views/Labels.vue'),
      meta: {
        title: Vue.i18n.translate('strings.labels', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'labelsDetail',
        component: () => import(/* webpackChunkName: "labels" */ '@/views/Labels.vue')
      }]
    },
    {
      path: '/preventivo-correctivo',
      name: 'orders',
      component: () => import(/* webpackChunkName: "orders" */ '@/views/Orders.vue'),
      meta: {
        title: 'Preventivo y correctivo',
        auth: {
          roles: ['Admin', 'Almacenista', 'Vendedor'],
          forbiddenRedirect: '/'
        }
      }
    },
    {
      path: '/orders',
      redirect: '/preventivo-correctivo'
    },
    {
      path: '/preventivo-correctivo/:id/corrective-review',
      name: 'order_corrective_review',
      component: () => import(/* webpackChunkName: "orders" */ '@/views/OrderCorrectiveReview.vue'),
      meta: {
        title: 'Revisión correctiva',
        auth: true
      }
    },
    {
      path: '/orders/:id/corrective-review',
      redirect: to => `/preventivo-correctivo/${to.params.id}/corrective-review`
    },
    {
      path: '/order_details',
      name: 'order_details',
      component: () => import(/* webpackChunkName: "order_details" */ '@/views/OrderDetails.vue'),
      meta: {
        title: Vue.i18n.translate('strings.order_details', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'orderDetailsDetail',
        component: () => import(/* webpackChunkName: "order_details" */ '@/views/OrderDetails.vue')
      }]
    },
    {
      path: '/receptions',
      name: 'receptions',
      component: () => import(/* webpackChunkName: "receptions" */ '@/views/Receptions.vue'),
      meta: {
        title: Vue.i18n.translate('strings.receptions', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'receptionsDetail',
        component: () => import(/* webpackChunkName: "receptions" */ '@/views/Receptions.vue')
      }]
    },
    {
      path: '/reception_details',
      name: 'reception_details',
      component: () => import(/* webpackChunkName: "reception_details" */ '@/views/ReceptionDetails.vue'),
      meta: {
        title: Vue.i18n.translate('strings.reception_details', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'receptionDetailsDetail',
        component: () => import(/* webpackChunkName: "reception_details" */ '@/views/ReceptionDetails.vue')
      }]
    },
    {
      path: '/transfers',
      name: 'transfers',
      component: () => import('@/views/Transfers.vue'),
      meta: {
        title: Vue.i18n.translate('strings.transfers', null),
        auth: {
          roles: ['Admin', 'Almacenista', 'Vendedor', 'Agente Aduanal'],
          forbiddenRedirect: '/'
        }
      }
    },
    {
      path: '/transfers/:id/detail',
      name: 'transfer_details',
      component: () => import(/* webpackChunkName: "purchase_orders" */ '@/views/TransferDetails.vue'),
      meta: {
        title: Vue.i18n.translate('strings.transfer_details', null),
        auth: {
          roles: ['Admin', 'Almacenista', 'Vendedor', 'Agente Aduanal'],
          forbiddenRedirect: '/'
        }
      }
    },
    {
      path: '/transfers/:id/tab',
      name: 'tab-transfers',
      component: () => import('@/views/TabTransfers.vue'),
      meta: {
        title: Vue.i18n.translate('strings.transfers', null),
        auth: true
      }
    },
    {
      path: '/locations',
      name: 'locations',
      component: () => import(/* webpackChunkName: "locations" */ '@/views/Locations.vue'),
      meta: {
        title: Vue.i18n.translate('strings.locations', null),
        auth: {
          roles: ['Admin', 'Almacenista', 'Vendedor'],
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'locationsDetail',
        component: () => import(/* webpackChunkName: "locations" */ '@/views/Locations.vue')
      }]
    },
    {
      path: '/purchase_orders',
      name: 'purchase_orders',
      component: () => import(/* webpackChunkName: "purchase_orders" */ '@/views/PurchaseOrders.vue'),
      meta: {
        title: Vue.i18n.translate('strings.purchase_orders', null),
        auth: {
          roles: ['Admin', 'Vendedor'],
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'purchaseOrdersDetail',
        component: () => import(/* webpackChunkName: "purchase_orders" */ '@/views/PurchaseOrders.vue')
      }]
    },
    {
      path: '/purchase_order/:id/detail',
      name: 'purchase_order_details',
      component: () => import(/* webpackChunkName: "purchase_orders" */ '@/views/PurchaseOrderDetails.vue'),
      meta: {
        title: Vue.i18n.translate('strings.purchase_orders', null),
        auth: {
          roles: ['Admin', 'Almacenista', 'Vendedor'],
          forbiddenRedirect: '/'
        }
      }
    },
    {
      path: '/suppliers',
      name: 'suppliers',
      component: () => import(/* webpackChunkName: "suppliers" */ '@/views/Suppliers.vue'),
      meta: {
        title: Vue.i18n.translate('strings.suppliers', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'suppliersDetail',
        component: () => import(/* webpackChunkName: "suppliers" */ '@/views/Suppliers.vue')
      }]
    },
    {
      path: '/warehouses',
      name: 'warehouses',
      component: () => import(/* webpackChunkName: "warehouses" */ '@/views/Warehouses.vue'),
      meta: {
        title: Vue.i18n.translate('strings.warehouses', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'warehousesDetail',
        component: () => import(/* webpackChunkName: "warehouses" */ '@/views/Warehouses.vue')
      }]
    },
    {
      path: '/shipments',
      name: 'shipments',
      component: () => import(/* webpackChunkName: "shipments" */ '@/views/Shipments.vue'),
      meta: {
        title: Vue.i18n.translate('strings.shipments', null),
        auth: {
          roles: ['Admin', 'Almacenista', 'Vendedor', 'Agente Aduanal'],
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'shipmentsDetail',
        component: () => import(/* webpackChunkName: "shipments" */ '@/views/Shipments.vue')
      }]
    },
    {
      path: '/shipment/:id/detail',
      name: 'shipment_details',
      component: () => import(/* webpackChunkName: "shipment_details" */ '@/views/ShipmentDetails.vue'),
      meta: {
        title: Vue.i18n.translate('strings.shipment_details', null),
        auth: {
          roles: ['Admin', 'Almacenista', 'Vendedor', 'Agente Aduanal'],
          forbiddenRedirect: '/'
        }
      }
    },
    {
      path: '/tab-shipments',
      name: 'tab-shipments',
      component: () => import(/* webpackChunkName: "shipments" */ '@/views/TabShipments.vue'),
      meta: {
        title: Vue.i18n.translate('strings.tab_shipments', null),
        auth: true
      }
    },
    {
      path: '/purchase_orders/:id/tab',
      name: 'tab-purchase-order',
      component: () => import(/* webpackChunkName: "shipments" */ '@/views/TabPurchaseOrder.vue'),
      meta: {
        title: Vue.i18n.translate('strings.purchase_orders', null),
        auth: true
      }
    },
    {
      path: '/branches',
      name: 'branches',
      component: () => import(/* webpackChunkName: "branches" */ '@/views/Branches.vue'),
      meta: {
        title: Vue.i18n.translate('strings.branches', null),
        auth: {
          roles: ['Admin', 'Almacenista', 'Vendedor'],
          forbiddenRedirect: '/'
        }
      }
    },
    {
      path: '/customers',
      name: 'customers',
      component: () => import(/* webpackChunkName: "branches" */ '@/views/Customers.vue'),
      meta: {
        title: Vue.i18n.translate('strings.customers', null),
        auth: {
          roles: ['Admin'],
          forbiddenRedirect: '/'
        }
      }
    },
    {
      path: '/error-catalogs',
      name: 'error_catalogs',
      component: () => import(/* webpackChunkName: "error_catalogs" */ '@/views/ErrorCatalogs.vue'),
      meta: {
        title: 'Catálogo de Errores',
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      }
    },
    {
      path: '/users',
      name: 'users',
      component: () => import(/* webpackChunkName: "users" */ '@/views/Users.vue'),
      meta: {
        title: Vue.i18n.translate('strings.users', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'userDetail',
        component: () => import(/* webpackChunkName: "users" */ '@/views/Users.vue')
      }]
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import(/* webpackChunkName: "privacy-policy" */ '@/views/PrivacyPolicy.vue'),
      meta: {
        title: 'Política de Privacidad',
        auth: false,
        public: true
      }
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (login.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "login" */ '@/views/Auth/AuthLogin.vue'),
      meta: {
        title: Vue.i18n.translate('login.login', null),
        auth: false
      }
    },
    {
      path: '/register',
      name: 'register',
      // route level code-splitting
      // this generates a separate chunk (register.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "register" */ '@/views/Auth/AuthRegister.vue'),
      meta: {
        title: Vue.i18n.translate('login.register', null),
        auth: false
      }
    },
    {
      path: '/password/reset',
      name: 'reset',
      component: () => import(/* webpackChunkName: "Reset" */ '@/views/Auth/AuthResetLink.vue'),
      meta: {
        title: Vue.i18n.translate('login.reset_password', null),
        auth: false
      }
    },
    {
      path: '/password/reset/:token',
      name: 'reset.token',
      component: () => import(/* webpackChunkName: "Reset" */ '@/views/Auth/AuthResetForm.vue'),
      meta: {
        title: Vue.i18n.translate('login.reset_password', null),
        auth: false
      }
    },
    {
      path: '/email/verify',
      name: 'verification.notice',
      props: true,
      component: () => import(/* webpackChunkName: "verification" */ '@/views/Auth/AuthVerify.vue'),
      meta: {
        title: Vue.i18n.translate('verification.title', null),
        auth: false
      }
    },
    {
      path: '/privacidad',
      name: 'privacidad',
      component: () => import(/* webpackChunkName: "privacidad" */ '@/views/Privacidad.vue'),
      meta: {
        title: Vue.i18n.translate('strings.privacidad', null)
      }
    }
  ]
})

// It's required for VueAuth
Vue.router = router

export default router
